import script from "./Conferences.vue?vue&type=script&setup=true&lang=js"
export * from "./Conferences.vue?vue&type=script&setup=true&lang=js"

import "./Conferences.vue?vue&type=style&index=0&id=ad73c150&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad73c150"]])

export default __exports__